module.exports = __webpack_public_path__ + "static/media/arrangement_automatique.a9056c49.mp4";